import '../styles/app.scss';
import './_images';
import './_fonts';
import Donations from "./components/Donations";

document.addEventListener(
	'DOMContentLoaded',
	() => {

		const backToCampaignButton = document.querySelectorAll('.back_to_campaign_checkout_button a');
		if(backToCampaignButton){
			backToCampaignButton.forEach(button => {
				button.href = document.referrer;
			})
		}

		function updateReturnButton() {
			let returnButton = document.querySelector(".return-to-shop a");
			if (returnButton && document.referrer) {
				returnButton.setAttribute("href", document.referrer);
			}
		}

		updateReturnButton();

		const observer = new MutationObserver(mutations => {
			mutations.forEach(mutation => {
				if (mutation.type === "childList") {
					updateReturnButton();
				}
			});
		});

		let cartContainer = document.querySelector("div.woocommerce");
		if (cartContainer) {
			observer.observe(cartContainer.parentNode, { childList: true, subtree: true });
		}

		new Donations().watchDonationFrequency();
	},
	false
);
